export const CACHE_KEY_PRODUCT_CREATE = 'product-create';
export const CACHE_KEY_PRODUCT_UPDATE = 'product-update';
